module.exports = __webpack_public_path__ + "static/media/anyvan.e3feb8b4.png";